require('jquery-validation');
require('lessRoot/gift-registry.less');
const Sortable = require("sortablejs").Sortable;

Blain.GiftRegistry = {

	init() {

		const self = this;

		/*=======================================================================
		== ReCAPTCHA Callback
		========================================================================*/

		window.purchasedRecaptchaCallback = function () {
			window.grecaptcha.render("markPurchasedCaptcha", {
				'sitekey': "6LeqjvsSAAAAAMxycMwxI2rtpYLUbzBfHHEjDvki"
			});
		};

		/*=======================================================================
		== Registry Landing Page Search Form
		========================================================================*/

		const $headerSearch = $("#grFinder .blain-form");
		if ($headerSearch.length) {
			$headerSearch.validate({
				rules: {
					firstName: "required",
					lastName: "required"
				}
			});
		}

		/*=======================================================================
		== Registry Search Page Sort/Filter
		========================================================================*/
		const $results = $('#grResults');
		if ($results.length) {

			function sortBy(option) {
				const sorted = $('.registry-card').sort(function(a, b) {
					a = $(a).find(`#${option}`).text().toLowerCase();
					b = $(b).find(`#${option}`).text().toLowerCase();

					if (option === 'eventDate') {
						return new Date(a) - new Date(b);
					} else {
						if (a < b) {
							return -1;
						}
						if (a > b) {
							return 1;
						}
						return 0;
					}
				});
				$('.results-content').html(sorted);
			}

			$('#searchSort').off("change").on("change", function() {
				sortBy($(this).val());
			});
		}

		/*=======================================================================
		== Create / Edit Registry Profile
		========================================================================*/

		const $createRegistry = $("#createRegistryForm");
		if ($createRegistry.length) {
			const $weddingForm = $createRegistry.hasClass("create-wedding");
			const $babyForm = $createRegistry.hasClass("create-baby");
			const $wishListForm = $createRegistry.hasClass("create-wishList");
			const $shoppingForm = $createRegistry.hasClass("create-shopping");
			const $customForm = $createRegistry.hasClass("create-custom");

			const searchableCheckbox = $createRegistry.find("label[for='agree']");

			searchableCheckbox.off("click").on("click", function() {
				const details = $createRegistry.find(".details-container");

				details.slideToggle();
			});


			const radioDivs1 = $(".pm-radio-1");
			const listTypeRadios = $("input[name='ListType']");
			listTypeRadios.off("change").on("change", function () {
				const parentDiv = $($(this)[0].parentElement);
				radioDivs1.removeClass("checked");
				parentDiv.addClass("checked");
			});

			$('.collab').off("click").on("click", function (e) {
				$('.collab-email').toggle();
			});

			$('#savedAddresses').off("change").on("change", function () {
				const selected = $(this).find(':selected');
				$('input[name=Address1]').val(selected.data("address1"));
				$('input[name=Address2]').val(selected.data("address2"));
				$('input[name=Zip]').val(selected.data("zip"));
				$('input[name=City]').val(selected.data("city"));
				$(`select[name=State] option[value=${selected.data("state")}]`).prop("selected", true);
			});

			$('#deleteList').off("click").on("click", function (e) {
				const listID = $(this).data("listid");

				$.ajax({
					method: "POST",
					url: '/gift-registry/delete-list',
					data: {
						listID
					},
					success: function(res) {
						location.reload();
					}
				});
			});

			let rules = {};
			if ($weddingForm) {
				rules = {
					"EventDate": {
						date: true
					},
					"FirstName": "required",
					"LastName": "required"
				};
			}
			if ($babyForm) {
				rules = {
					"EventDate": {
						date: true
					},
					"FirstName": "required",
					"LastName": "required"
				};
			}
			if ($wishListForm) {
				rules = {
					"EventDate": {
						date: true
					},
					"FirstName": "required",
					"LastName": "required",
					"CoFirstName": {
						required: "#childCheck:checked"
					},
					"CoLastName": {
						required: "#childCheck:checked"
					},
				};
			}
			if ($shoppingForm) {
				rules = {
					"ListTitle": "required"
				};
			}
			if ($customForm) {
				rules = {
					"EventDate": {
						date: true
					},
					"FirstName": "required",
					"LastName": "required",
				};
			}

			$createRegistry.validate({
				rules,
				submitHandler: function(form) {
					form.submit();
				}
			});


		}

		/*=======================================================================
		== Shopping List Add Temp Item
		========================================================================*/
		const $addTemp = $("#shoppingAddTemp");
		if ($addTemp.length) {
			const listID = $addTemp.data("listid");

			$($addTemp).validate({
				rules: {
					"description": "required",
				},
				submitHandler: function(form) {
					const description = $("#descriptionInput").val();

					$.ajax({
						url: "/gift-registry/add-temp-item",
						method: "POST",
						data: {
							listItem: {
								listID,
								description
							}
						},
						success: function(res) {
							location.reload();
						}
					});
				}
			});
		}


		/*=======================================================================
		== Shopping List
		========================================================================*/

		function initSearch() {
			//Search
			const searchInput = $(".input-container").find("input[name='search']");
			let searchValue;

			searchInput.off("keyup").on("keyup", function (e) {
				searchValue = $(this).val();
			});

			$("#shoppingAddTemp").off("keyup").on("keyup", function (e) {
				if (e.which == 13 && searchValue.length) {
					e.preventDefault();
					window.location.href = `./search=${searchValue}`;
				}
			});

			$("#shoppingAddTempSearch").off("keyup").on("keyup", function (e) {
				if (e.which == 13 && searchValue.length) {
					e.preventDefault();
					const oldHref = window.location.href.split('/');
					oldHref.pop();
					oldHref.pop();
					const newHref = oldHref.join('/');
					window.location.href = `${newHref}/search=${searchValue}`;
				}
			});
		};

		initSearch();

		const $shoppingList = $("#shoppingList");
		if ($shoppingList.length) {
			const el = document.getElementById('items');
			const listID = el.dataset.listid;

			let selectedSort;
			let sortedOutOfCustom;

			if (!$shoppingList.hasClass("shopping-list-search")) {
				 new Sortable(el, {
					animation: 150,
					ghostClass: 'selected-ghost',
					handle: ".handle",
					swapThreshold: 4,
					direction: 'vertical',
					disabled: false,
					onSort: function (event) {
						if (selectedSort !== 'custom') {
							sortedOutOfCustom = true;
							$("#listSort").val('custom');
						}

						const childArr = [...event.to.children];
						const updatedItems = childArr.map((item, i) => {
							const note = $(item).find(".note").text();
							const qtyWanted = $(item).find(".req-qty-field").val();

							return {
								listID,
								blainNumber: item.dataset.blainnumber,
								description: item.dataset.description,
								id: item.dataset.itemid,
								position: i,
								note,
								qtyWanted
							};
						});

						$.ajax({
							url: "/gift-registry/update-shopping-list/",
							method: "POST",
							data: {
								updatedItems
							}
						});
						bindItemInputs();
					},
					onChoose: function (event) {
						//if the mobile details section is open, close it and toggle icon
						const mobileDetails = $(event.item).find(".mobile-details-container");
						if (mobileDetails.is(":visible")) {
							mobileDetails.removeClass("active");
							$(event.item).find(".toggleIcon").replaceWith('<i class="toggleIcon fa fa-chevron-down"</i>');
							bindItemInputs();
						}

						if ($(window).width() > 900) {
							$(event.item).find(".highlight").toggle();
						} else {
							$(event.item).find(".mobile-left-tab").toggleClass("mobile-left-tab-active");
						}

						$(event.item).find(".lt-icon-container").toggleClass("selected-tab-border");
						bindItemInputs();
					},
					onUnchoose: function(event) {
						if ($(window).width() > 900) {
							$(event.item).find(".highlight").toggle();
						} else {
							$(event.item).find(".mobile-left-tab").toggleClass("mobile-left-tab-active");
						}

						$(event.item).find(".lt-icon-container").toggleClass("selected-tab-border");
						bindItemInputs();
					},
				});
			}

			bindItemInputs();

			/*=======================================================================
			== Header Sort
			========================================================================*/
			const itemContainer = $("#items");
			const listItems = itemContainer.children();

			initSearch();

			//Sort
			const listSort = $("#listSort");

			listSort.off("change").on("change", function() {
				selectedSort = $(this).children("option:selected").val();

				if (selectedSort === 'custom' && sortedOutOfCustom) return;

				const sortedList = listItems.sort(function(a, b) {
					let elementOne;
					let elementTwo;

					//find elements
					if (selectedSort === 'custom') {
						elementOne = $(a).data("position");
						elementTwo = $(b).data("position");
					}
					if (selectedSort === 'alpha') {
						elementOne = $(a).find(".name").text().toUpperCase();
						elementTwo = $(b).find(".name").text().toUpperCase();
					}
					if (selectedSort === 'department') {
						elementOne = $(a).data("department");
						elementTwo = $(b).data("department");
					}
					if (selectedSort === 'high') {
						const decimalOne = $(b).find(".price").text().replace('$', '');
						elementOne = Math.round(decimalOne * 100);
						const decimalTwo = $(a).find(".price").text().replace('$', '');
						elementTwo = Math.round(decimalTwo * 100);
					}
					if (selectedSort === 'low') {
						const decimalOne = $(a).find(".price").text().replace('$', '');
						elementOne = Math.round(decimalOne * 100);
						const decimalTwo = $(b).find(".price").text().replace('$', '');
						elementTwo = Math.round(decimalTwo * 100);
					}

					//sort elements
					if (elementOne < elementTwo) {
						return -1;
					}
					if (elementOne > elementTwo) {
						return 1;
					}
					return 0;

				});

				itemContainer.html(sortedList);
				bindItemInputs();
				initSearch();

			});


			function bindItemInputs() {
				$('#items li').each(function (i, item) {
					const $reqQtyBtns = $(item).find(".req-qty-btn");
					const $reqQty = $(item).find(".req-qty-field");
					const $reqSub = $reqQtyBtns.eq(0);
					const $reqAdd = $reqQtyBtns.eq(1);

					//mobile qty btns
					const $reqQtyBtnsMobile = $(item).find(".req-qty-btn-mobile");
					const $reqQtyMobile = $(item).find(".req-qty-field-mobile");
					const $reqSubMobile = $reqQtyBtnsMobile.eq(0);
					const $reqAddMobile = $reqQtyBtnsMobile.eq(1);

					const $blainNumber = $(item).data('blainnumber');
					const $itemID = $(item).data('itemid');

					/*=======================================================================
					== Mark as completed
					========================================================================*/
					$(item).find(".sli-check").off("click").on("click", function () {
						$.ajax({
							url: "/gift-registry/update-item",
							method: "POST",
							data: {
								listItem: {
									listID,
									id: $itemID,
									qtyWanted: $reqQty.val(),
									qtyPurchased: $reqQty.val(),
									note: $(item).find(".note").text(),
									position: i
								},
							},
							success: function (res) {
								location.reload();
							}
						});
					});

					$(item).find(".sli-check-completed").off("click").on("click", function () {
						$.ajax({
							url: "/gift-registry/update-item",
							method: "POST",
							data: {
								listItem: {
									listID,
									id: $itemID,
									qtyWanted: $reqQty.val(),
									qtyPurchased: 0,
									note: $(item).find(".note").text(),
									position: -1
								},
							},
							success: function (res) {
								location.reload();
							}
						});
					});

					/*=======================================================================
					== bind mobile buttons
					========================================================================*/

					$(item).find(".mobile-details-link").off("click").on("click", function () {
						$(item).find(".mobile-details-container").toggleClass("active");
						const chevronIcon = $(item).find(".toggleIcon");
						if (chevronIcon.hasClass("fa-chevron-up")) {
							chevronIcon.replaceWith('<i class="toggleIcon fa fa-chevron-down"></i>');
							bindItemInputs();
						} else if (chevronIcon.hasClass("fa-chevron-down")) {
							chevronIcon.replaceWith('<i class="toggleIcon fa fa-chevron-up"></i>');
							bindItemInputs();
						}
					});

					//hide mobile details container when the resolution is resized passed mobile width
					$(window).resize(function () {
						if ($(window).width() > 900) {
							$(".mobile-details-container").removeClass("active");
							bindItemInputs();
						}
					});

					/*=======================================================================
					== Stock Status Modal
					========================================================================*/

					const $stockStatusForm = $("#stockStatusForm");

					$stockStatusForm.validate({
						submitHandler: function () {
							doStockStatusLookup($blainNumber, $("#stockStatusZip").val());
						}
					});

					const $changeStoreTrigger = $(item).find(".change-local-store");

					$changeStoreTrigger.off("click").on("click", function(e) {
						e.preventDefault();
						const zipCode = $("#currentStore").attr("data-blain-zipcode");
						$("#stockStatusZip").val(zipCode);
						$("#stockStatusBlainNumber").val($blainNumber);
						doStockStatusLookup($blainNumber);
					});


					function doStockStatusLookup(blainNumber, zip) {
						const $stockStatusModal = $("#stockStatusModal");
						const $stockStatusProgress = $("#stockStatusProgress");
						const $stockStatusContainer = $("#stockStatusContainer");
						const $stockStatusNoResults = $("#stockStatusNoResults");

						$stockStatusNoResults.hide();
						$stockStatusContainer.hide();
						$stockStatusProgress.show();
						$stockStatusModal.blainModal("show");
						$stockStatusModal.find('#stockStatusZip').focus();


						$.ajax({
							url: "/products/a/stockstatus",
							data: {
								blainNumber,
								zip
							},
							type: "POST",
							success: function (res) {
								if (!res.Success) {
									$stockStatusNoResults.show();
								}

								if (res.HtmlString) {
									$stockStatusProgress.hide();
									$stockStatusContainer.html(res.HtmlString).show();
									Blain.GlobalEventListeners.init($stockStatusContainer[0]);
								} else {
									$stockStatusProgress.hide();
								}
							}
						});
					}

					$reqQty.off("keypress").on("keypress", (e) => {
						if (e.which < 48 || e.which > 57) {
							e.preventDefault();
						}
						if (e.which === 13) {
							$reqQty.change();
						}
					}).off("change").on("change", function (e) {
						if ($reqQty.val() == 1) {
							$reqSub.addClass('disabled-btn');
							$reqSub.attr("disabled", true);
						}
						if ($reqQty.val() > 1) {
							$reqSub.removeClass('disabled-btn');
							$reqSub.attr("disabled", false);
						}
						if ($reqQty.val() < 1) {
							$reqQty.val(1);
							return;
						}

						$.ajax({
							url: "/gift-registry/update-item",
							method: "POST",
							data: {
								listItem: {
									listID,
									id: $itemID,
									qtyWanted: $reqQty.val(),
									note: $(item).find(".note").text(),
									position: i
								},
								updateHeader: true
							},
							success: function (res) {
								if (res.TotalCount && res.SubTotal) {
									const totalCount = $(".gr-needed-shopping").find("#shoppingTotalCount");
									const subTotal = $(".gr-needed-shopping").find("#shoppingSubTotal");

									totalCount.text(res.TotalCount);
									subTotal.text(`$${res.SubTotal}`);
								}
							}
						});
					});

					$reqSub.off("click").on("click", function() {
						if ($reqQty.val() > 1) {
							const qty = parseInt($reqQty.val()) - 1;
							$reqQty.val(qty).change();
						}
					});

					$reqAdd.off("click").on("click", function() {
						const qty = parseInt($reqQty.val()) + 1;
						$reqQty.val(qty).change();
					});

					//mobile button events
					$reqQtyMobile.off("keypress").on("keypress", (e) => {
						if (e.which < 48 || e.which > 57) {
							e.preventDefault();
						}
						if (e.which === 13) {
							$reqQtyMobile.change();
						}
					}).off("change").on("change", function (e) {
						if ($reqQtyMobile.val() < 1) {
							$reqQtyMobile.val(1);
							return;
						}

						$.ajax({
							url: "/gift-registry/update-item",
							method: "POST",
							data: {
								listItem: {
									listID,
									id: $itemID,
									qtyWanted: $reqQtyMobile.val(),
									note: $(item).find(".note").text(),
									position: i
								},
								updateHeader: true
							},
							success: function (res) {
								if (res.TotalCount && res.SubTotal) {
									const totalCount = $(".gr-needed-shopping").find("#shoppingTotalCount");
									const subTotal = $(".gr-needed-shopping").find("#shoppingSubTotal");

									totalCount.text(res.TotalCount);
									subTotal.text(`$${res.SubTotal}`);
								}
							}
						});
					});

					$reqSubMobile.off("click").on("click", function() {
						if ($reqQtyMobile.val() > 1) {
							const qty = parseInt($reqQtyMobile.val()) - 1;
							$reqQtyMobile.val(qty).change();
						}
					});

					$reqAddMobile.off("click").on("click", function() {
						const qty = parseInt($reqQtyMobile.val()) + 1;
						$reqQtyMobile.val(qty).change();
					});

					//Bind Modals
					function bindNoteModal(selector) {
						selector.off("click").on("click", function() {
							$("#addNoteModal").blainModal("show");
							$('#addNoteModal').find('#note').focus();
							const existingNote = $(item).find(".note").text();
							if (existingNote) {
								const trimmed = $.trim(existingNote);
								$("#addNoteForm").find("#note").val(trimmed);
							} else {
								$("#addNoteForm").find("#note").val("");
							}

							$("#addNoteModal").find("#grCancel").off("click").on("click", function(e) {
								e.preventDefault();
								$("#addNoteModal").blainModal("hide");
							});

							$("#addNoteForm").validate({
								submitHandler: function(form) {
									$("#updateNote").html('<i class="fa fa-spin fa-gear"></i> Sending').prop("disabled", true);

									const note = $("#addNoteForm").find("#note").val();

									$.ajax({
										url: "/gift-registry/update-item",
										method: "POST",
										data: {
											listItem: {
												listID,
												note,
												id: $itemID,
												qtyWanted: $reqQty.val(),
												position: i
											}
										},
										success: function(res) {
											location.reload();
										}
									});
								}
							});
						});
					}



					const noteButton = $(item).find(".addNote");
					const noteIcon = $(item).find("#addNoteIcon");
					bindNoteModal(noteButton);
					bindNoteModal(noteIcon);



					$(item).find(".transferItem").off("click").on("click", function() {
						$("#transferItemModal").blainModal("show");
						$("#transferItemModal").find('#selectList').focus();

						$("#transferItemModal").find("#grCancel").off("click").on("click", function(e) {
							e.preventDefault();
							$("#transferItemModal").blainModal("hide");
						});

						const newListID = $("#selectList option:selected").val();

						$("#transferItemModal").validate({
							submitHandler: function(form) {
								$("#transferItemButton").html('<i class="fa fa-spin fa-gear"></i> Sending').prop("disabled", true);

								$.ajax({
									url: `/gift-registry/transfer-item/${listID}/${newListID}/${$itemID}`,
									method: "POST",
									success: function(res) {
										location.reload();
									}
								});
							}
						});
					});

					$(item).find(".deleteItem").off("click").on("click", function() {
						$("#deleteItemModal").blainModal("show");
						$("#deleteItemModal").find("button.close").first().focus();


						$("#deleteItemModal").find("#grCancel").off("click").on("click", function(e) {
							e.preventDefault();
							$("#deleteItemModal").blainModal("hide");
						});

						$("#deleteItemModal").validate({
							submitHandler: function(form) {
								$("#removeItem").html('<i class="fa fa-spin fa-gear"></i> Sending').prop("disabled", true);

								$.ajax({
									url: `/gift-registry/remove-item/${listID}/${$itemID}`,
									method: "POST",
									success: function(res) {
										location.reload();
									}
								});
							}
						});
					});

				});
			}

		}

		/*=======================================================================
		== Email To A Friend
		========================================================================*/

		const $emailRegistryModal = $("#emailRegistryModal");
		if ($emailRegistryModal.length) {
			const $emailRegistryForm = $emailRegistryModal.find("#emailRegistryForm");
			const $emailRegistrySubmit = $emailRegistryModal.find("#grSubmit");
			const $emailRegistry = $(".email-registry");

			$emailRegistryModal.find("#grCancel").on("click", function(e) {
				e.preventDefault();
				$emailRegistryModal.blainModal("hide");
			});

			$emailRegistry.on("click", function() {
				$emailRegistryModal.blainModal("show");
			});


			$emailRegistryForm.validate({
				rules: {
					"msg": "required",
					"emails": {
						required: true,
						multiemails: true
					}
				},
				messages: {
					"emails": {
						multiemails: "Emails must be separated by with a comma"
					}
				},
				submitHandler: function(form) {
					$emailRegistrySubmit.html('<i class="fa fa-spin fa-gear"></i> Sending').prop("disabled", true);

					const $listID = $emailRegistryModal.find("#grRegID").val();
					const $listType = $emailRegistryModal.find("#grListType").val();
					const $emails = $emailRegistryModal.find("#grEmails").val();
					const $message = $emailRegistryModal.find("#grMsg").val();

					$.ajax({
						url: "/gift-registry/email",
						method: "POST",
						data: {
							customerListID: $listID,
							emails: $emails,
							msg: $message
						},
						success: function(res) {
							$emailRegistryModal.blainModal("hide");
							$.modalMsg({
								title: "Thank You!",
								message: "Your message has been sent.",
								width: "narrow"
							});

							// GTM event
							blainGtmDataLayer.push({
								'customerListType': $listType,
								'event': "customer_list_share"
							});

						},
						error: function(xhr) {
							$emailRegistryModal.blainModal("hide");
							const obj = $.parseAjaxError(xhr);
							$.globalAjaxError(obj);
						},
						complete: function() {
							$emailRegistryModal.find("#grEmails").val("");
							$emailRegistryModal.find("#grMsg").val("");
						}
					});
				}
			});
		}

		/*=======================================================================
		== Edit Product Details
		========================================================================*/

		function bindEditDetailsButtons() {
			const $editRegistryDetailsModal = $("#editRegistryDetailsModal");
			if ($editRegistryDetailsModal.length) {
				const $markPurchased = $(".mark-as-purchased");
				const $viewRegistryItem = $(".view-registry-item");
				const $updateRegistryItem = $(".update-item-details");

				$updateRegistryItem.off("click").on("click", function() {
					$editRegistryDetailsModal.blainModal("show");

					$('.registry-modal-content').html('<i class="fa fa-spin fa-gear blue"></i>...');
					const $productBlainNumber = $(this).data("blainnumber");
					const $registryId = $(this).data("registryid");

					$.ajax({
						type: "POST",
						url: `/gift-registry/registry-modal/${$registryId}/${$productBlainNumber}/update-item`,
						dataType: "html",
						contentType: "application/json",
						error: function (xhr) {
							$('#updateRegistryItemModalContent').remove('fa-gear');
							$.globalAjaxError(xhr);
						},
						success: function (data) {
							$editRegistryDetailsModal
								.find('.registry-modal-content')
								.html(JSON.parse(data).html);
							$editRegistryDetailsModal.find('.lc-product-link').first().focus();
							//Requested Quantity Selector
							const $reqQtyBtns = $editRegistryDetailsModal.find(".req-qty-btn");
							const $reqQty = $editRegistryDetailsModal.find(".req-qty-field");
							const $reqSub = $reqQtyBtns.eq(0);
							const $reqAdd = $reqQtyBtns.eq(1);
							//Purchased Quantity Selector
							const $purQtyBtns = $editRegistryDetailsModal.find(".purchased-qty-btn");
							const $purQty = $editRegistryDetailsModal.find(".purchased-qty-field");
							const $purSub = $purQtyBtns.eq(0);
							const $purAdd = $purQtyBtns.eq(1);
							//Remove Button
							const $removeBtn = $editRegistryDetailsModal.find(".remove-registry-item");
							const $updateBtn = $editRegistryDetailsModal.find(".update-registry-item");

							$editRegistryDetailsModal.find("#rcbCancel, .close").off("click").on("click", function(e) {
								$('.rcf-quantity-wrapper').toggleClass('disabled-opacity');
								$('.qty-btn').prop("disabled", (x, v) => !v);
								e.preventDefault();
								$editRegistryDetailsModal.blainModal("hide");
							});

							//Requested Quantity Selector
							$reqQty.off("keypress").on("keypress", (e) => {
								if (e.which < 48 || e.which > 57) {
									e.preventDefault();
								}
								if (e.which === 13) {
									$reqQty.change();
								}
							}).off("change").on("change", function () {
								if ($reqQty.val() < 1) {
									$reqQty.val(1);
									return;
								}
								if ($reqQty.val() > 1) {
									$reqSub.removeClass("disabled");
								} else {
									$reqSub.addClass("disabled");
								}
							});

							$reqSub.off("click").on("click", function() {
								if ($reqQty.val() > 1) {
									const qty = parseInt($reqQty.val()) - 1;
									$reqQty.val(qty).change();
								}
							});

							$reqAdd.off("click").on("click", function() {
								const qty = parseInt($reqQty.val()) + 1;
								$reqQty.val(qty).change();
							});


							//Purchased Quantity Selector
							$purQty.off("keypress").on("keypress", (e) => {
								if (e.which < 48 || e.which > 57) {
									e.preventDefault();
								}
								if (e.which === 13) {
									$purQty.change();
								}
							}).off("change").on("change", function () {
								if ($purQty.val() < 0) {
									$purQty.val(0);
									return;
								}
								if ($purQty.val() > 1) {
									$purSub.removeClass("disabled");
								} else {
									$purSub.addClass("disabled");
								}
							});

							$purSub.off("click").on("click", function() {
								if ($purQty.val() > 0) {
									const qty = parseInt($purQty.val()) - 1;
									$purQty.val(qty).change();
								}
							});

							$purAdd.off("click").on("click", function() {
								const qty = parseInt($purQty.val()) + 1;
								$purQty.val(qty).change();
							});

							//Remove Item
							$removeBtn.off("click").on("click", function() {
								$removeBtn.html('<i class="fa fa-spin fa-gear"></i>...');

								const $itemID = $(".right-column").data("itemid");
								const $registryID = $(".right-column").data("registryid");

								$.ajax({
									type: "POST",
									url: `/gift-registry/remove-item/${$registryID}/${$itemID}`,
									dataType: "html",
									contentType: "application/json",
									error: function (xhr) {
										$removeBtn.remove('.fa-gear');
										$editRegistryDetailsModal.blainModal("hide");
										const obj = $.parseAjaxError(xhr);
										$.globalAjaxError(obj);
									},
									success: function (data) {
										location.reload();
									}
								});
							});

							//Update Item
							$updateBtn.off("click").on("click", function() {
								$updateBtn.html('<i class="fa fa-spin fa-gear"></i>...');
								const $form = $('.right-column');
								const data = {
									ListID: $form.data("registryid"),
									BlainNumber: $form.data("blainnumber"),
									ID: $form.data("itemid"),
									QtyWanted: $form.find('input[name="qtyWanted"]').val(),
									QtyPurchased: $form.find('input[name="qtyPurchased"]').val(),
									MostDesired: $form.find('input[name="mostWanted"]').is(":checked"),
									Note: $form.find('textarea.note').val()
								};

								$.ajax({
									url: "/gift-registry/update-item/",
									method: "POST",
									data: data,
									success: function(res) {
										location.reload();
									},
									error: function(xhr) {
										$updatebtn.html("Update");
										$editRegistryDetailsModal.blainModal("hide");
										const obj = $.parseAjaxError(xhr);
										$.globalAjaxError(obj);
									}
								});
							});
						}
					});
				});

				$viewRegistryItem.off("click").on("click", function() {
					$('.registry-modal-content').html('<i class="fa fa-spin fa-gear blue"></i>...');
					$editRegistryDetailsModal.blainModal("show");
					const $productBlainNumber = $(this).data("blainnumber");
					const $registryId = $(this).data("registryid");

					$.ajax({
						type: "POST",
						url: `/gift-registry/registry-modal/${$registryId}/${$productBlainNumber}/view-item`,
						dataType: "html",
						contentType: "application/json",
						error: function (xhr) {
							$('#viewRegistryItemModalContent').remove('.fa-gear');
							$.globalAjaxError(xhr);
						},
						success: function (data) {
							data = $.parseJSON(data);
							$editRegistryDetailsModal.find('.registry-modal-content').html(data.html);

							const $markAsPurchased = $editRegistryDetailsModal.find(".mark-as-purchased");

							$editRegistryDetailsModal.find("#rcbCancel, .close").off("click").on("click", function(e) {
								e.preventDefault();
								$editRegistryDetailsModal.blainModal("hide");
							});


							$markAsPurchased.off("click").on("click", function() {
								$('#viewRegistryItemModalContent').html('<i class="fa fa-spin fa-gear blue"></i>...');

								const $productBlainNumber = $(this).data("blainnumber");
								const $registryId = $(this).data("registryid");

								$.ajax({
									type: "POST",
									url: `/gift-registry/registry-modal/${$registryId}/${$productBlainNumber}/purchased`,
									dataType: "html",
									contentType: "application/json",
									error: function (xhr) {
										$('#viewRegistryItemModalContent').remove('.fa-gear');
										$.globalAjaxError(xhr);
									},
									success: function (data) {
										data = $.parseJSON(data);
										$editRegistryDetailsModal.find('.registry-modal-content').html(data.html);
										const $submitButton = $editRegistryDetailsModal.find("#rcbSubmit");
										const $qtyBtns = $editRegistryDetailsModal.find(".qty-btn");
										const $qty = $editRegistryDetailsModal.find(".qty-field");
										const $productNeeded = $editRegistryDetailsModal.find(".rcf-quantity-wrapper").data("qtyneeded");
										const $sub = $qtyBtns.eq(0);
										const $add = $qtyBtns.eq(1);
										$.getScript("//www.google.com/recaptcha/api.js?onload=purchasedRecaptchaCallback&render=explicit", function () { });
										$editRegistryDetailsModal.find("#rcbCancel, .close").on("click", function(e) {
											e.preventDefault();
											window.grecaptcha = undefined;
											$editRegistryDetailsModal.blainModal("hide");
										});

										$editRegistryDetailsModal.find("#alreadyPurchased").on("click", function() {
											$('.rcf-quantity-wrapper').toggleClass('disabled-opacity');
											$('.qty-btn').prop("disabled", (x, v) => !v);
											$submitButton.toggleClass("disabled");
										});

										$submitButton.off("click").on("click", function() {
											if ($(this).hasClass("disabled")) return;
											$submitButton.html('<i class="fa fa-spin fa-gear"></i>...');

											const $captchaResponse = window.grecaptcha.getResponse();

											$.ajax({
												type: "POST",
												url: `/gift-registry/update-purchased`,
												data: {
													listID: $registryId,
													blainNumber: $productBlainNumber,
													qtyPurchased: $qty.val(),
													captcha: $captchaResponse
												},
												error: function (xhr) {
													$submitButton.html('Submit');
													$('.captcha-error').hide();
													$.globalAjaxError(xhr);
												},
												success: function (res) {
													if (res.Success) {
														location.reload();
													}
													if (!res.Success && res.CaptchaFailed) {
														$submitButton.html('Submit');
														$('.captcha-error').show();
													}
												}
											});
										});

										$qty.off("keypress").on("keypress", (e) => {
											if (e.which < 48 || e.which > 57) {
												e.preventDefault();
											}
											if (e.which === 13) {
												$qty.change();
											}
										}).off("change").on("change", function () {
											if ($qty.val() > $productNeeded) {
												$qty.val($productNeeded);
												return;
											}
											if ($qty.val() < 1) {
												$qty.val(1);
												return;
											}
											if ($qty.val() > 1) {
												$sub.removeClass("disabled");
											} else {
												$sub.addClass("disabled");
											}
										});

										$sub.off("click").on("click", function() {
											if ($qty.val() > 1) {
												const qty = parseInt($qty.val()) - 1;
												$qty.removeClass("max-qty-red");
												$qty.val(qty).change();
											}
										});

										$add.off("click").on("click", function() {
											if (parseInt($qty.val()) < $productNeeded) {
												const qty = parseInt($qty.val()) + 1;
												$qty.val(qty).change();
											} else {
												$add.addClass("disabled");
												return;
											}
										});
									}
								});
							});
						}

					});
				});

				$markPurchased.off("click").on("click", function() {
					$('.registry-modal-content').html('<i class="fa fa-spin fa-gear blue"></i>...');
					$editRegistryDetailsModal.blainModal("show");

					const $productBlainNumber = $(this).data("blainnumber");
					const $registryId = $(this).data("registryid");

					$.ajax({
						type: "POST",
						url: `/gift-registry/registry-modal/${$registryId}/${$productBlainNumber}/purchased`,
						dataType: "html",
						contentType: "application/json",
						error: function (xhr) {
							$('#alreadyPurchasedModalContent').remove('.fa-gear');
							$.globalAjaxError(xhr);
						},
						success: function (data) {
							data = $.parseJSON(data);
							$editRegistryDetailsModal.find('.registry-modal-content').html(data.html);
							const $submitButton = $editRegistryDetailsModal.find("#rcbSubmit");
							const $qtyBtns = $editRegistryDetailsModal.find(".qty-btn");
							const $qty = $editRegistryDetailsModal.find(".qty-field");
							const $productNeeded = $editRegistryDetailsModal.find(".rcf-quantity-wrapper").data("qtyneeded");
							const $sub = $qtyBtns.eq(0);
							const $add = $qtyBtns.eq(1);

							$.getScript("//www.google.com/recaptcha/api.js?onload=purchasedRecaptchaCallback&render=explicit", function () { });

							$editRegistryDetailsModal.find("#rcbCancel, .close").off("click").on("click", function(e) {
								e.preventDefault();
								window.grecaptcha = undefined;
								$editRegistryDetailsModal.blainModal("hide");
							});

							$editRegistryDetailsModal.find("#alreadyPurchased").on("click", function() {
								$('.rcf-quantity-wrapper').toggleClass('disabled-opacity');
								$('.qty-btn').prop("disabled", (x, v) => !v);
								$submitButton.toggleClass("disabled");
							});

							$submitButton.off("click").on("click", function() {
								if ($(this).hasClass("disabled")) return;
								$submitButton.html('<i class="fa fa-spin fa-gear"></i>...');

								const $captchaResponse = window.grecaptcha.getResponse();

								$.ajax({
									type: "POST",
									url: `/gift-registry/update-purchased`,
									data: {
										listID: $registryId,
										blainNumber: $productBlainNumber,
										qtyPurchased: $qty.val(),
										captcha: $captchaResponse
									},
									error: function (xhr) {
										$submitButton.html('Submit');
										$('.captcha-error').hide();
										$.globalAjaxError(xhr);
									},
									success: function (res) {
										if (res.Success) {
											location.reload();
										}
										if (!res.Success && res.CaptchaFailed) {
											$submitButton.html('Submit');
											$('.captcha-error').show();
										}
									}
								});
							});


							$qty.off("keypress").on("keypress", (e) => {
								if (e.which < 48 || e.which > 57) {
									e.preventDefault();
								}
								if (e.which === 13) {
									$qty.change();
								}
							}).off("change").on("change", function () {
								if ($qty.val() > $productNeeded) {
									$qty.val($productNeeded);
									return;
								}
								if ($qty.val() < 1) {
									$qty.val(1);
									return;
								}
								if ($qty.val() > 1) {
									$sub.removeClass("disabled");
								} else {
									$sub.addClass("disabled");
								}
							});

							$sub.off("click").on("click", function() {
								if ($qty.val() > 1) {
									const qty = parseInt($qty.val()) - 1;
									$qty.removeClass("max-qty-red");
									$qty.val(qty).change();
								}
							});

							$add.off("click").on("click", function() {
								if (parseInt($qty.val()) < $productNeeded) {
									const qty = parseInt($qty.val()) + 1;
									$qty.val(qty).change();
								} else {
									$add.addClass("disabled");
									return;
								}
							});
						}
					});
				});
			}
		}
		bindEditDetailsButtons();


		/*=======================================================================
		== Registry View Filter
		========================================================================*/
		const $filterForm = $(".selectable-section");
		if ($filterForm.length) {
			const $inputs = $(".selectable-section :input");
			const data = {};
			let lastChecked = '';
			$inputs.each(function () {
				$(this).off("click").on("click", function () {
					const cb = $(this);
					data.mostWanted = $("#mostWanted").is(":checked");
					if (cb.val() !== "on") {
						if (lastChecked !== cb.val()) {
							lastChecked = cb.val();
							data.priceFilter = cb.val();
						} else {
							cb.prop("checked", false);
							lastChecked = '';
							data.priceFilter = null;
						}
					}

					$.ajax({
						method: "POST",
						data,
						success: function(res) {
							$("#productListGrid").replaceWith(res.html);
							bindEditDetailsButtons();
						}
					});

				});
			});
		};

	},
};

(function($) {
	$(document).ready(function() {
		Blain.GiftRegistry.init();
	});
})(jQuery);